import { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Flex, Tag, Typography } from 'antd';
import { QuestionEdit } from '.';

export const FormReview = () => {
  const defaultQuestion = {
    enabled: true,
    type: 'text',
    question: '',
    required: true,
  };

  const [form, setForm] = useState([]);
  const addQuestion = () => {
    setForm((prev) => [...prev, { ...defaultQuestion, id: prev.length }]);
  };
  const removeQuestion = (id) => {
    setForm((prev) => prev.filter((item) => item.id !== id));
  };

  const handleValue = (id, key, value) => {
    setForm((prev) => prev.map((item) => (item.id === id ? { ...item, [key]: value } : item)));
  };

  return (
    <div>
      <Flex align="center" justify="space-between">
        <Typography.Paragraph>
          Review and customize your questions. All questions are selected by default.
        </Typography.Paragraph>
        <Tag color="blue">
          {form.filter((q) => q.enabled).length} of {form.length} Selected
        </Tag>
      </Flex>

      <Flex vertical gap={16}>
        {form.map((question, idx) => (
          <QuestionEdit
            key={question.id}
            question={question}
            number={idx + 1}
            onChange={handleValue}
            onSave={() => {}}
            onCancel={() => {}}
            removeQuestion={() => removeQuestion(question.id)}
          />
        ))}
      </Flex>

      <Flex
        vertical
        align="center"
        gap={16}
        style={{ border: '1px dashed #d1d5db', borderRadius: 8, marginTop: 16, padding: 24 }}>
        <Button icon={<PlusOutlined />} onClick={addQuestion}>
          Add Question
        </Button>
        <Typography.Text type="secondary">Create additional questions specific to your needs</Typography.Text>
      </Flex>
    </div>
  );
};
